import * as React from 'react';
import { GridPivotPanelHeader } from "./GridPivotPanelHeader.js";
import { GridPivotPanelBody } from "./GridPivotPanelBody.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function GridPivotPanel() {
  const [searchValue, setSearchValue] = React.useState('');
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(GridPivotPanelHeader, {
      searchValue: searchValue,
      onSearchValueChange: setSearchValue
    }), /*#__PURE__*/_jsx(GridPivotPanelBody, {
      searchValue: searchValue
    })]
  });
}
export { GridPivotPanel };